import { atom } from "recoil";

export const previewState = atom({
	key: "previewwwwwState",
	default: {
		isPreview: false,
	},
});
